import { _addDefaultHeaders, _getConfig } from "./helper.js";
const DEFAULT_MESSAGE = '<<ERROR>>: Došlo k chybě při přístupu na <<URL>> s parametry <<OPTIONS>>';
class DekError extends Error {
    status;
    constructor(message, status = 418) {
        super(message);
        this.status = status;
    }
}
class DekAutomatError extends DekError {
    constructor(message, status = 418) {
        super(message);
        this.status = status;
    }
}
class DekApiError extends DekError {
    constructor(url, options, error, status) {
        super(getMessage(url.toString(), JSON.stringify(options), error), status);
        this.name = error;
    }
}
class CorsError extends DekApiError {
    constructor(url, options) {
        super(url, options, 'CORS chyba [CorsError]', 418);
    }
}
class NetworkError extends DekApiError {
    constructor(url, options) {
        super(url, options, 'Síťová chyba [NetworkError]', 418);
    }
}
class TimeoutError extends DekApiError {
    constructor(url, options) {
        super(url, options, 'Chyba časového limitu [TimeoutError]', 408);
    }
}
// class AbortError extends DekApiError {
//     constructor(url: URL, options: DekOptions) {
//         super(url, options, 'Požadavek byl přerušen [AbortError]', 418)
//     }
// }
class OfflineError extends DekApiError {
    constructor(url, options) {
        super(url, options, 'Není připojení k internetu [OfflineError]', 418);
    }
}
/**
 * Identifikuje typ chyby a ukládá do logu
 */
function identifyError(error, url, options, saveError = true) {
    if (error instanceof DekError) {
        saveError && void saveToApiLog(error);
    }
    // CORS Error
    else if (error instanceof TypeError && (error.message.includes('CORS') ||
        error.message.includes('Cross-Origin Resource Sharing') ||
        error.message.includes('Access-Control-Allow-Origin'))) {
        saveError && void saveToApiLog(new CorsError(url, options));
    }
    // Network Error
    else if (error instanceof TypeError && (error.message.includes('NetworkError') ||
        error.message.includes('network error') ||
        error.message.includes('Network request failed'))) {
        saveError && void saveToApiLog(new NetworkError(url, options));
    }
    // Timeout Error
    else if (error instanceof TypeError && error.message.includes('timeout')) {
        saveError && void saveToApiLog(new TimeoutError(url, options));
    }
    // Abort Error
    else if (error instanceof DOMException && error.name === 'AbortError') {
        //chceme logovat abort error?
        // void saveToApiLog(new AbortError(url, options))
    }
    // Offline Error
    else if (error instanceof TypeError && !navigator.onLine) {
        saveError && void saveToApiLog(new OfflineError(url, options));
    }
    // Type Error
    else if (error instanceof TypeError && error.message.includes('Failed to fetch')) {
        saveError && void saveToApiLog(new DekApiError(url, options, 'Typová chyba (CORS?)', 418));
    }
    // Unknown Error
    else {
        saveError && void saveToApiLog(new DekApiError(url, options, 'Neznámá chyba', 418));
    }
}
/**
 * Vytvoří textovou zprávu pro chybu
 */
function getMessage(url, options, error) {
    return DEFAULT_MESSAGE
        .replace('<<ERROR>>', error)
        .replace('<<URL>>', url)
        .replace('<<OPTIONS>>', options);
}
/**
 * Získá origin z stacku
 */
function _getOrigin(stack) {
    if (!stack)
        return '';
    const lines = stack.split('\n');
    const originLine = lines.find(line => line.includes('at '));
    if (!originLine)
        return '';
    const reactIndex = originLine.indexOf('/react/');
    const indexIndex = originLine.indexOf('/index');
    if (reactIndex === -1 || indexIndex === -1)
        return '[react]: Neznámá app';
    const appName = originLine.slice(reactIndex + 7, indexIndex);
    return `[react]: ${appName}`;
}
/**
 * Uloží chybu do API logu
 */
async function saveToApiLog(error) {
    try {
        const config = _getConfig();
        const origin = _getOrigin(error.stack);
        const body = {
            status: error.status,
            origin,
            message: error.message,
        };
        const url = new URL('/log/save-error', config.api.base);
        const headers = new Headers();
        headers.set('Content-Type', 'application/json');
        const options = _addDefaultHeaders({
            headers,
        });
        const response = await fetch(url, {
            ...options,
            method: 'POST',
            body: JSON.stringify(body)
        });
        if (!response.ok) {
            console.error('Nepodařilo se uložit error log:', response.status, response.statusText);
        }
    }
    catch (e) {
        console.error('Nepodařilo se uložit error log:', e);
    }
}
/**
 * @deprecated
 */
class ErrorClient extends Error {
    constructor(response) {
        super('Chyba klienta');
        this.name = 'ErrorClient';
        this.response = response;
        this.status = response.status;
    }
    response;
    status;
}
/**
 * @deprecated
 */
class ErrorServer extends Error {
    constructor(response) {
        super('Chyba serveru');
        this.name = 'ErrorServer';
        this.response = response;
        this.status = response.status;
    }
    response;
    status;
}
export { getMessage, saveToApiLog, identifyError, DekError, DekApiError, DekAutomatError, 
// temporary
ErrorClient, ErrorServer, };
